import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        // Scroll to top when location changes
        window.scrollTo(0, 0);
    }, [location]);

    return null; // This component doesn't need to render anything
};

export default ScrollToTop;
